export const groupProducts = (products) => {
  const productMap = new Map();

  const allProducts = products.forEach(product => {
    const productId = product._id;

    if (productMap.has(productId)) {
      const existingProduct = productMap.get(productId);

      existingProduct.counter += product.counter || 0;
      existingProduct.totalAmount += product.totalAmount || 0;
      existingProduct.totalCount += product.totalCount || 0;

      if (product.variant && product.variantInfo && existingProduct.variantInfo) {
        product.variantInfo.forEach((newVariant, index) => {
          if (existingProduct.variantInfo[index]) {
            existingProduct.variantInfo[index].counterVariant += newVariant.counterVariant || 0;
          }
        });
      }

      if (product.selectedVariants && product.selectedVariants.length > 0) {
        const combinedVariants = [...(existingProduct.selectedVariants || []), ...product.selectedVariants];
        existingProduct.selectedVariants = [...new Set(combinedVariants.filter(v => v !== "" && v !== null && v !== undefined))];
      }
    } else {
      productMap.set(productId, {
        ...product,
        variantInfo: product.variantInfo ? product.variantInfo.map((v) => ({ ...v })) : [],
        selectedVariants: product.selectedVariants ? [...product.selectedVariants] : []
      });
    }
  });

  const groupedProducts = Array.from(productMap.values());

  return groupedProducts;
}